var module = angular.module('octopusApp.projects');

module.directive('dualValueAdder', function($timeout) {
    return {
        restrict: 'E',
        transclude: true,
        templateUrl:'areas/projects/actions/docker_network/dual-value-adder.html',
        require: 'ngModel',
        scope: {
            action: '=',
            project: '=',
            localNames: '=',
            placeholder1: '@',
            placeholder2: '@',
            helptext: '@',
            template: '@',
            seperator: '@'
        },

        compile: function (tElem, attrs) {
            tElem.find('.itemTemplate').html(attrs.template || "{{item.Item1}} = {{item.Item2}}");
            delete attrs.template;
            return {
                pre: function ($scope, iElem, iAttrs, ngModel) {
                    var vm = $scope.vm;
                    vm.valuesUpdated = function valuesUpdated() {
                        var newValue = JSON.stringify(vm.items.reduce(function(obj, item) {
                            obj[item.itemVal1] = item.itemVal2;
                            return obj;
                        }, {}));
                        ngModel.$setViewValue(newValue);
                    };

                    ngModel.$render = function onRender() {
                        if (ngModel.$viewValue) {
                            try {
                                var obj = JSON.parse(ngModel.$viewValue);
                                vm.items = _.map(obj, function (value, name) {
                                    return {
                                        itemVal1: name,
                                        editItemVal1: name,
                                        itemVal2:  value,
                                        editItemVal2:  value
                                    };
                                });
                            } catch (err) {
                                console.error(err);
                            }
                        }
                    };
                }
            };
        },

        controller: function() {
            var vm = this;

            vm.addItem = addItem;
            vm.newItemVal1 = "";
            vm.newItemVal2 = "";
            vm.editContainer = "";
           
            vm.cancelEdit = cancelEdit;
            vm.commitEdit = commitEdit;
            vm.remove = remove;
            vm.items = [];
            vm.isEditing = false;

            function addItem() {
                vm.items.push({itemVal1: vm.newItemVal1, editItemVal1: vm.newItemVal1, itemVal2:  vm.newItemVal2, editItemVal2:  vm.newItemVal2});
                vm.valuesUpdated();
                vm.newItemVal1 = "";
                vm.newItemVal2 = "";
            }

            function commitEdit(container) {
                container.isEditing = false;
                container.itemVal1 = container.editItemVal1;
                container.itemVal2 = container.editItemVal2;
                vm.valuesUpdated();
            }

            function remove(container) {
                var idx = vm.items.indexOf(container);
                if (idx >= 0) {
                    vm.items.splice(idx, 1);
                }
                vm.valuesUpdated();
            }

            function cancelEdit(container) {
                container.isEditing = false;
                container.editItemVal1 = container.itemVal1;
                container.editItemVal2 = container.itemVal2;
            }
        },
        controllerAs: 'vm',
        bindToController: true
    };
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/actions/docker_network/dual-value-adder.js
// module id = 8617129935594814
// module chunks = 1